var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCard = function SvgCard(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 24C2 24.9283 2.36875 25.8185 3.02513 26.4749C3.6815 27.1313 4.57174 27.5 5.5 27.5H26.5C27.4283 27.5 28.3185 27.1313 28.9749 26.4749C29.6313 25.8185 30 24.9283 30 24V14.375H2V24ZM6.125 19.25C6.125 18.7527 6.32254 18.2758 6.67417 17.9242C7.02581 17.5725 7.50272 17.375 8 17.375H11C11.4973 17.375 11.9742 17.5725 12.3258 17.9242C12.6775 18.2758 12.875 18.7527 12.875 19.25V20.5C12.875 20.9973 12.6775 21.4742 12.3258 21.8258C11.9742 22.1775 11.4973 22.375 11 22.375H8C7.50272 22.375 7.02581 22.1775 6.67417 21.8258C6.32254 21.4742 6.125 20.9973 6.125 20.5V19.25ZM26.5 5.5H5.5C4.57174 5.5 3.6815 5.86875 3.02513 6.52513C2.36875 7.1815 2 8.07174 2 9V10.625H30V9C30 8.07174 29.6313 7.1815 28.9749 6.52513C28.3185 5.86875 27.4283 5.5 26.5 5.5Z",
    fill: "#59995C"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/card.fd34a6ea5b371ddf894f9af9f6444977.svg";